import { render } from "./OrderUpdate.vue?vue&type=template&id=8769ebd8&scoped=true"
import script from "./OrderUpdate.vue?vue&type=script&lang=js"
export * from "./OrderUpdate.vue?vue&type=script&lang=js"

import "./OrderUpdate.vue?vue&type=style&index=0&id=8769ebd8&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8769ebd8"]])

export default __exports__